import { patchRequest, deleteRequest } from './base_requests';

export function moveElement(elementID, newPosition) {
  return patchRequest({ url: `/api/elements/${elementID}/move_position`, body: { new_position: newPosition } })
}

export function deleteElement(elementID) {
  return deleteRequest({ url: `/api/elements/${elementID}` })
}
